import ImageComponent from '@sharedComponent/image-component';
import React from 'react';

function OptionTick({ selectedEmirate, option, value }) {
	return (
		<>
			<div className="option-ticks">
				<div>{option}</div>
				<div className="tick-icon">
					{selectedEmirate === 'allemirates' || value === selectedEmirate ? (
						<ImageComponent className="tick-enabled true-tick" />
					) : (
						<ImageComponent className="tick" style={{ paddingRight: 4 }} />
					)}
				</div>
			</div>
		</>
	);
}

export default OptionTick;
